import React from 'react';

const StoreSearch = ({
  handleSearchInput,
  button_disable,
  handleSearchButton,
}) => {
  return (
    <div className="store_search">
      <strong>검색으로 매장 찾기</strong>
      <div className="select_box">
        <select name="area" onChange={handleSearchInput}>
          <option value="0" defaultValue>
            전국
          </option>
          <option value="1">서울/경기/인천</option>
          <option value="2">부산</option>
          <option value="3">대전/충청</option>

          <option value="4">광주/전라</option>
          <option value="5">대구</option>
          <option value="6">울산/경상</option>
          <option value="7">강원</option>
          <option value="8">제주</option>
        </select>
      </div>
      <input
        onChange={handleSearchInput}
        type="text"
        name="search_text"
        placeholder="검색어를 입력하세요"
        title="검색어 입력"
      />
      <button
        disabled={button_disable}
        className={button_disable ? '' : 'on'}
        onClick={handleSearchButton}
      >
        매장찾기
      </button>
    </div>
  );
};

export default StoreSearch;
